import PreviewPageView from 'src/pages/PreviewPage/view'
import thumbnail1 from 'src/assets/images/preview/preview_hotdeal_thumbnail1.png'
import thumbnail2 from 'src/assets/images/preview/preview_hotdeal_thumbnail2.png'
import thumbnail3 from 'src/assets/images/preview/preview_hotdeal_thumbnail3.png'
import category1 from 'src/assets/images/preview/preview_category1.png'
import category2 from 'src/assets/images/preview/preview_category2.png'
import category3 from 'src/assets/images/preview/preview_category3.png'
import category4 from 'src/assets/images/preview/preview_category4.png'
import category5 from 'src/assets/images/preview/preview_category5.png'
import category6 from 'src/assets/images/preview/preview_category6.png'
import useParamsType from 'src/hooks/useParamsType.hook'
import { ExternalBridge } from 'src/utils/externalBridge'
import { useEffect } from 'react'
import { useModal } from 'src/provider/ModalContextProvider'
import RecommendPartnerJoin from 'src/components/common/Modal/children/RecommendPartnerJoin'

export interface PreviewPageProps {
  hotDealCouponList: {
    CouponName: string
    CouponImage: string
    BrandName: string
    RegularPrice: number
    SalePrice: number
    DiscountRate: number
  }[]
  alwaysDiscountCategoryList: {
    CategoryNumber: number
    CategoryName: string
    LowestPrice: number
    CategoryImage: string
  }[]
  handleExternalOpenUrl: (redirectPath: string) => void
}

const HOT_DEAL_COUPON_LIST = [
  {
    CouponName: '슈퍼슈프림(오리지널) L + 콜라 1.25L',
    CouponImage: thumbnail1,
    BrandName: '도미노피자',
    RegularPrice: 30200,
    SalePrice: 12080,
    DiscountRate: 60,
  },
  {
    CouponName: '초코빽스치노(소프트)',
    CouponImage: thumbnail2,
    BrandName: '빽다방',
    RegularPrice: 4300,
    SalePrice: 2150,
    DiscountRate: 50,
  },
  {
    CouponName: '기분좋은 소금버터 식빵',
    CouponImage: thumbnail3,
    BrandName: '뚜레쥬르',
    RegularPrice: 4000,
    SalePrice: 1800,
    DiscountRate: 55,
  },
]

const ALWAYS_DISCOUNT_CATEGORY_LIST = [
  {
    CategoryNumber: 9,
    CategoryName: '카페',
    CategoryImage: category1,
    LowestPrice: 1440,
  },
  {
    CategoryNumber: 8,
    CategoryName: '치킨',
    CategoryImage: category2,
    LowestPrice: 17100,
  },
  {
    CategoryNumber: 2,
    CategoryName: '패스트푸드',
    CategoryImage: category3,
    LowestPrice: 4120,
  },
  {
    CategoryNumber: 1,
    CategoryName: '베이커리',
    CategoryImage: category4,
    LowestPrice: 3380,
  },
  {
    CategoryNumber: 4,
    CategoryName: '생활',
    CategoryImage: category5,
    LowestPrice: 13800,
  },
  {
    CategoryNumber: 7,
    CategoryName: '외식',
    CategoryImage: category6,
    LowestPrice: 7000,
  },
]

const PreviewPage = () => {
  const { pCode } = useParamsType()
  const { openModal } = useModal()
  const isFirstSession = !sessionStorage.getItem('already_preview_join_popup')

  const handleExternalOpenUrl = (redirectPath: string) => {
    if (pCode?.includes('alyac')) {
      return ExternalBridge.ALYAC.startOutLinkUrl(pCode, redirectPath)
    }
  }

  useEffect(() => {
    if (isFirstSession) {
      openModal({ type: 'custom', contents: { children: <RecommendPartnerJoin /> } })
      sessionStorage.setItem('already_preview_join_popup', 'true')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFirstSession])

  const props: PreviewPageProps = {
    hotDealCouponList: HOT_DEAL_COUPON_LIST,
    alwaysDiscountCategoryList: ALWAYS_DISCOUNT_CATEGORY_LIST,
    handleExternalOpenUrl,
  }

  return <PreviewPageView {...props} />
}

export default PreviewPage
